import React from "react";
import { createContext, useState } from "react";
import { LoadingOverlay } from "../components/LoadingOverlay";

export const LoadingOverlayContext = createContext({ setLoadingOverlay: () => null })

export function LoadingOverlayProvider({ children }) {
    const [loadingOverlay, setLoadingOverlay] = useState(false);

    return (
        <LoadingOverlayContext.Provider value={{ setLoadingOverlay }}>
            {loadingOverlay && <LoadingOverlay dialogMessage="Carregando" />}
            {children}
        </LoadingOverlayContext.Provider>
    )
}
